<section class="bg-color-base-keyline " id="news-letter">
    <div class="container">
        <div class="d-flex d-flexs justify-content-between align-item-center heading">
            <div class="mb-40 md:w-auto md:mb-0 pr-40 pr-50  ">
                <h2 class="mb-20 news-heading text-color text-56 mb-0">
                    {{'newsletter.sign_up_to_newsletter'|translate}}
                </h2>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10  ml-auto form-section">
                <!-- [formGroup]="newsLetterSignUp" -->
                <form [formGroup]="newsLetterSignUp">
                    <div class="row d-flex">
                        <div class="col-7 col-md-9 col-lg-7 col-xl-7 emaildiv">
                            <label class="lbl_login" for="pwd"></label>
                            <div class="input-group">
                                <input type="email" id="email" formControlName="email"
                                    class="form-control form-control-lg" (input)="resetMessage()"
                                    placeholder="{{'newsletter.placeholder'|translate}}">
                            </div>
                        </div>
                        <div class="col-5 col-md-3 col-lg-5 col-xl-5 mt-1 " >
                            <button type="submit" (click)="onSubmit()" class="explore-button ml-2">
                                {{'newsletter.submit'|translate}}
                            </button>
                        </div>
                    </div>
                    <div class="row  error-width pt-2">
                        <div class="col-12 pl-4">
                            <span class="text-danger" >{{errormsg|translate}}</span>
                            <span class="text-danger" >{{alreadyExist |translate}}</span>
                            <span class="text-primary " 
                                >{{newsLetterMesssage|translate}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>